module.exports = __webpack_public_path__ + "static/media/haya.a717c3a5.jpg";